<template>
  <footer class="footer">
    <div class="footer-bg-animation"></div>
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo">
            <h3>汉语基础平台</h3>
            <div class="logo-badge">AI Powered</div>
          </div>
          <p>让中文世界的每一次表达，都被精准理解</p>
          <div class="social-links">
            <a href="#" class="social-link github" title="GitHub">
              <i class="fab fa-github"></i>
            </a>
            <a href="#" class="social-link wechat" title="微信">
              <i class="fab fa-weixin"></i>
            </a>
            <a href="#" class="social-link weibo" title="微博">
              <i class="fab fa-weibo"></i>
            </a>
            <a href="#" class="social-link twitter" title="Twitter">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="social-link linkedin" title="LinkedIn">
              <i class="fab fa-linkedin"></i>
            </a>
            <a href="#" class="social-link youtube" title="YouTube">
              <i class="fab fa-youtube"></i>
            </a>
          </div>
          <div class="newsletter">
            <h4>订阅我们的新闻通讯</h4>
            <div class="newsletter-form">
              <input type="email" placeholder="您的邮箱地址" class="newsletter-input">
              <button class="newsletter-btn">订阅</button>
            </div>
          </div>
        </div>
        
        <div class="footer-section">
          <h4>产品</h4>
          <ul>
            <li><a href="#capabilities"><i class="fas fa-chevron-right"></i> 核心能力</a></li>
            <li><a href="#scenarios"><i class="fas fa-chevron-right"></i> 应用场景</a></li>
            <li><a href="#cases"><i class="fas fa-chevron-right"></i> 成功案例</a></li>
            <li><a href="#pricing"><i class="fas fa-chevron-right"></i> 价格方案</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 更新日志</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 路线图</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>资源</h4>
          <ul>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 文档中心</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> API 参考</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 社区论坛</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 技术博客</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 开发者工具</a></li>
            <li><a href="#"><i class="fas fa-chevron-right"></i> 开源项目</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>联系我们</h4>
          <div class="contact-info">
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <div class="contact-details">
                <span class="contact-label">邮箱</span>
                <a href="mailto:contact@han-basic.com">contact@han-basic.com</a>
              </div>
            </div>
            <div class="contact-item">
              <i class="fas fa-phone"></i>
              <div class="contact-details">
                <span class="contact-label">电话</span>
                <a href="tel:400-123-4567">400-123-4567</a>
              </div>
            </div>
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <div class="contact-details">
                <span class="contact-label">地址</span>
                <span>北京市朝阳区科技园</span>
              </div>
            </div>
          </div>
          <div class="footer-apps">
            <h4>下载应用</h4>
            <div class="app-buttons">
              <a href="#" class="app-button">
                <i class="fab fa-apple"></i>
                <div class="app-info">
                  <span class="app-small">Download on the</span>
                  <span class="app-large">App Store</span>
                </div>
              </a>
              <a href="#" class="app-button">
                <i class="fab fa-google-play"></i>
                <div class="app-info">
                  <span class="app-small">Get it on</span>
                  <span class="app-large">Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p>&copy; {{ currentYear }} 汉语基础平台. 保留所有权利.</p>
          <div class="footer-links">
            <a href="#">隐私政策</a>
            <a href="#">服务条款</a>
            <a href="#">Cookie设置</a>
            <a href="#">法律声明</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: #ecf0f1;
  padding: 80px 0 20px;
  position: relative;
  overflow: hidden;
  
  .footer-bg-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 10% 20%, rgba(75, 107, 251, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 90% 80%, rgba(126, 87, 194, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 50% 50%, rgba(75, 107, 251, 0.02) 0%, transparent 70%);
    z-index: 0;
  }
  
  .container {
    position: relative;
    z-index: 1;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 50px;
    margin-bottom: 50px;
  }
  
  .footer-section {
    h3, h4 {
      margin-bottom: 25px;
      color: #ffffff;
      font-weight: 600;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
        border-radius: 3px;
      }
    }
    
    p {
      margin-bottom: 25px;
      line-height: 1.7;
      color: #bdc3c7;
      font-size: 16px;
    }
    
    ul {
      list-style: none;
      
      li {
        margin-bottom: 15px;
        
        a {
          color: #bdc3c7;
          text-decoration: none;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          
          i {
            margin-right: 10px;
            font-size: 12px;
            color: var(--primary-color);
            transition: all 0.3s ease;
          }
          
          &:hover {
            color: #ffffff;
            padding-left: 5px;
            
            i {
              color: var(--secondary-color);
            }
          }
        }
      }
    }
  }
  
  .footer-logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    
    h3 {
      margin-bottom: 10px;
      
      &::after {
        display: none;
      }
    }
    
    .logo-badge {
      background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
      color: white;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 15px;
      box-shadow: 0 4px 10px rgba(75, 107, 251, 0.3);
    }
  }
  
  .social-links {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    
    .social-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45px;
      height: 45px;
      background-color: rgba(255, 255, 255, 0.05);
      border-radius: 50%;
      margin-right: 12px;
      margin-bottom: 10px;
      color: #ffffff;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 0;
      }
      
      i {
        position: relative;
        z-index: 1;
        font-size: 18px;
      }
      
      &:hover {
        transform: translateY(-5px);
        
        &::before {
          opacity: 1;
        }
      }
      
      &.github:hover {
        background-color: #333;
        &::before {
          background: linear-gradient(135deg, #333 0%, #555 100%);
        }
      }
      
      &.wechat:hover {
        background-color: #07c160;
        &::before {
          background: linear-gradient(135deg, #07c160 0%, #00a040 100%);
        }
      }
      
      &.weibo:hover {
        background-color: #e6162d;
        &::before {
          background: linear-gradient(135deg, #e6162d 0%, #c21230 100%);
        }
      }
      
      &.twitter:hover {
        background-color: #1da1f2;
        &::before {
          background: linear-gradient(135deg, #1da1f2 0%, #0c85d0 100%);
        }
      }
      
      &.linkedin:hover {
        background-color: #0077b5;
        &::before {
          background: linear-gradient(135deg, #0077b5 0%, #005885 100%);
        }
      }
      
      &.youtube:hover {
        background-color: #ff0000;
        &::before {
          background: linear-gradient(135deg, #ff0000 0%, #cc0000 100%);
        }
      }
    }
  }
  
  .newsletter {
    margin-top: 30px;
    
    h4 {
      font-size: 18px;
      margin-bottom: 15px;
      
      &::after {
        width: 30px;
      }
    }
    
    .newsletter-form {
      display: flex;
      
      .newsletter-input {
        flex: 1;
        padding: 12px 15px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 8px 0 0 8px;
        color: #ffffff;
        font-size: 14px;
        outline: none;
        transition: all 0.3s ease;
        
        &::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }
        
        &:focus {
          border-color: var(--primary-color);
          background-color: rgba(255, 255, 255, 0.1);
        }
      }
      
      .newsletter-btn {
        padding: 12px 20px;
        background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
        color: white;
        border: none;
        border-radius: 0 8px 8px 0;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(75, 107, 251, 0.3);
        }
      }
    }
  }
  
  .contact-info {
    margin-bottom: 30px;
    
    .contact-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      
      i {
        color: var(--primary-color);
        font-size: 18px;
        margin-right: 15px;
        margin-top: 2px;
      }
      
      .contact-details {
        flex: 1;
        
        .contact-label {
          display: block;
          font-size: 12px;
          color: #95a5a6;
          margin-bottom: 5px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        a, span {
          color: #ffffff;
          font-size: 15px;
          text-decoration: none;
          transition: color 0.3s ease;
          
          &:hover {
            color: var(--primary-color);
          }
        }
      }
    }
  }
  
  .footer-apps {
    h4 {
      font-size: 18px;
      margin-bottom: 15px;
      
      &::after {
        width: 30px;
      }
    }
    
    .app-buttons {
      display: flex;
      flex-direction: column;
      gap: 10px;
      
      .app-button {
        display: flex;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 10px 15px;
        color: #ffffff;
        text-decoration: none;
        transition: all 0.3s ease;
        
        i {
          font-size: 24px;
          margin-right: 15px;
        }
        
        .app-info {
          display: flex;
          flex-direction: column;
          
          .app-small {
            font-size: 10px;
            color: #bdc3c7;
          }
          
          .app-large {
            font-size: 14px;
            font-weight: 500;
          }
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }
      }
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 30px;
    
    .footer-bottom-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      
      p {
        color: #95a5a6;
        font-size: 14px;
        margin: 0;
      }
      
      .footer-links {
        display: flex;
        
        a {
          color: #95a5a6;
          text-decoration: none;
          font-size: 14px;
          margin-left: 20px;
          transition: color 0.3s ease;
          
          &:hover {
            color: #ffffff;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 991px) {
  .footer {
    padding: 60px 0 20px;
    
    .footer-content {
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
    }
    
    .footer-bottom-content {
      flex-direction: column;
      align-items: flex-start;
      
      .footer-links {
        margin-top: 15px;
        
        a {
          margin-left: 0;
          margin-right: 20px;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .footer {
    padding: 50px 0 20px;
    
    .footer-content {
      grid-template-columns: 1fr;
      gap: 30px;
    }
    
    .social-links {
      .social-link {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        
        i {
          font-size: 16px;
        }
      }
    }
    
    .newsletter-form {
      flex-direction: column;
      
      .newsletter-input {
        border-radius: 8px;
        margin-bottom: 10px;
      }
      
      .newsletter-btn {
        border-radius: 8px;
      }
    }
    
    .footer-bottom-content {
      .footer-links {
        flex-wrap: wrap;
        
        a {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>